"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.parse = exports.TypeReg = void 0;
const tslib_1 = require("tslib");
const interfaces_1 = require("./interfaces");
tslib_1.__exportStar(require("./interfaces"), exports);
/**
 * 目前支持的语法
 * 1 危险文本 [danger]xxxxx[:danger]
 * 2 警告文本 [warning]xxxxx[:warning]
 * 3 解释文本 ??xxxxx??(xxxxx)
 * 4 跳转链接 [xxxxx](xxxxx)
 */
exports.TypeReg = {
    [interfaces_1.TextType.DANGER]: /\[danger\]((?!\[danger\]).+?)\[:danger\]/,
    [interfaces_1.TextType.WARNING]: /\[warning\]((?!\[warning\]).+?)\[:warning\]/,
    [interfaces_1.TextType.INFO]: /\?\?(.+?)\?\?\((.+?)\)/,
    [interfaces_1.TextType.LINK]: /\[((?!(?::?(?:danger|warning)])).+?)\]\((.+?)\)/
};
// 规则：就近原则，标记之间不会嵌套，如果有嵌套目前先删除
function parse(oriStr) {
    const markupList = [];
    let match;
    for (let type of Object.keys(exports.TypeReg)) {
        const reg = new RegExp(exports.TypeReg[type], 'g');
        while ((match = reg.exec(oriStr)) !== null) {
            markupList.push({
                from: match.index,
                to: match.index + match[0].length,
                type
            });
        }
    }
    markupList.sort((a, b) => {
        return a.from - b.from;
    });
    const finalMarkupList = [];
    markupList.forEach((markup) => {
        const { from, to, type } = markup;
        const lastMarkup = finalMarkupList[finalMarkupList.length - 1];
        if (!lastMarkup || lastMarkup.to < from) {
            finalMarkupList.push({
                from: (lastMarkup === null || lastMarkup === void 0 ? void 0 : lastMarkup.to) || 0,
                to: from,
                type: interfaces_1.TextType.PLAIN
            });
        }
        else if (lastMarkup.from <= from && lastMarkup.to >= to) {
            return;
        }
        finalMarkupList.push({
            from,
            to,
            type
        });
    });
    const lastMarkup = finalMarkupList[finalMarkupList.length - 1];
    if (!lastMarkup || lastMarkup.to < oriStr.length) {
        finalMarkupList.push({
            from: (lastMarkup === null || lastMarkup === void 0 ? void 0 : lastMarkup.to) || 0,
            to: oriStr.length,
            type: interfaces_1.TextType.PLAIN
        });
    }
    return finalMarkupList.map(({ from, to, type }) => {
        const subStr = oriStr.substring(from, to);
        if (type === interfaces_1.TextType.PLAIN) {
            return {
                content: subStr,
                type
            };
        }
        const reg = new RegExp(exports.TypeReg[type]);
        const match = reg.exec(subStr);
        const ret = {
            content: (match === null || match === void 0 ? void 0 : match[1]) || '',
            type
        };
        if (type === interfaces_1.TextType.INFO || type === interfaces_1.TextType.LINK) {
            ret.addon = (match === null || match === void 0 ? void 0 : match[2]) || '';
        }
        return ret;
    });
}
exports.parse = parse;
//# sourceMappingURL=index.js.map